import * as THREE from 'three';

/**
 * 색을 <b>계열만</b> 옮긴다 — 색상·채도는 `tint` 의 것을 쓰고, <b>밝기는 원래 것을 남긴다</b>.
 *
 * <h2>왜 통째로 칠하지 않는가</h2>
 * 알갱이 팔레트는 색 열한 개가 «짙은 그늘 → 몸 색 → 테두리 → 흰 하이라이트» 로 층을 이룬다.
 * 그 층이 알갱이의 입체감 전부다. 전부 같은 색으로 칠하면 층이 사라져 빨간 점 뭉치가 된다.
 * 밝기를 남기면 짙은 것은 짙은 적갈색이 되고 <b>흰 것은 흰 채로 남는다</b>.
 *
 * <h2>HSL 로 오가는 것은 의도한 것이다</h2>
 * three 의 `getHSL`/`setHSL` 은 기본이 sRGB 라 작업 색공간과 한 번씩 오간다. 같은 기준으로
 * 왕복하므로 색이 어긋나지 않고, 「밝기」도 눈이 보는 밝기에 가깝게 나온다.
 */
export function tintColor(color: THREE.Color, tint: THREE.Color) {
  const from = { h: 0, s: 0, l: 0 };
  const to = { h: 0, s: 0, l: 0 };
  color.getHSL(from);
  tint.getHSL(to);
  return new THREE.Color().setHSL(to.h, to.s, from.l);
}

/** 같은 변환을 `Vector3` 로 적힌 색에. 셰이더가 `vec3` 로 받는 자리가 있다. */
export function tintVector(vector: THREE.Vector3, tint: THREE.Color) {
  const shifted = tintColor(new THREE.Color(vector.x, vector.y, vector.z), tint);
  return new THREE.Vector3(shifted.r, shifted.g, shifted.b);
}
